import {
  getFontsizeSmall,
  getMidPoint,
  getPointDistance, getPointField, getPointOnTheLine,
} from "../../../helpers/sqftHelper";
import ShapeHelper from "../../../helpers/shapeHelper";
//import COLOR_THEMES from "../../../../../colorThemes";
import COLOR_THEMES, {COLOR} from "../store/colorThemes";
import sqftConfig from "../store/sqftConfig";
//import workspace from "../core/workspace";
import {
  RENDER_TEMPLATES,
  SIDEBAR_BUTTONS_MENU,
} from "../../../constants";
import {getDistanceLength, getLineCrownMoldingPoints} from "./lineHelper";
import RenderCabinets from "./renderCabinets";
import RenderFigures from "./renderFigures";
import {COLORS as Colors} from "../../../../../colorThemes";
import store from "../../../../../store";
import config from "../store/sqftConfig";
import workspace from "../core/workspace";

export default class RenderParts {
  static drawMeasurementAroundPoints = (ctx, points, minLength = 3) => {
    points.forEach((point, index) => {
      const nextPoint = points[index + 1] ? points[index + 1] : points[0];
      const midPoint = getMidPoint(point, nextPoint);
      const distance = getPointDistance(point, nextPoint);
      const scale = workspace.getScale();
      if (distance / scale > minLength) {
        //const length = addDecimalToLength(measureDistanceToInches(distance / sqftConfig.scale));
        const length = getDistanceLength(distance / sqftConfig.scale);
        //debugger // eslint-disable-line no-debugger
        const lineOrientation = ShapeHelper.getLineOrientation(point, nextPoint);
        const mText = ctx.measureText(length);
        let fontSize = getFontsizeSmall(),
          font = (fontSize).toString() + "px " + sqftConfig.activeFontBold,
          xMargin = 0,
          yMargin = 0,
          pos = midPoint
        ;

        //todo change index logic
        switch (lineOrientation) {
          case "horizontal": {
            yMargin = index === 0
              ? -fontSize + sqftConfig.scale / sqftConfig.defaultScale
              : +fontSize + sqftConfig.scale / sqftConfig.defaultScale + 10;
            break;
          }
          case "vertical": {
            xMargin = index === 1 ? mText.width + 5 : -mText.width;
            break;
          }
          // todo rotation
          case "NORTHWEST": { break;}
          case "NORTHEAST": { break;}
          case "SOUTHWEST": { break;}
          case "SOUTHEAST": { break;}
          default:
            break;
        }
        pos.x += xMargin;
        pos.y += yMargin;

        ctx.beginPath();
        ctx.font = font;
        ctx.textAlign = "center"; //todo
        ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
        ctx.wrapText(length.toString(), pos.x, pos.y, mText.width, font);
        ctx.stroke();
        ctx.closePath();
      }
    })
  }

  static drawShapeBorders = (ctx, staticOffset, strokeTemplate, fillTemplate, shape) => {
    if (sqftConfig.isDevMode()) {
      RenderParts.renderDevMode(ctx, shape);
    }
    let lines = shape.getLines();
    const reduxState = store.getState();
    const isShowSlabTool = reduxState.sqftSlabState.isShowSlabTool;

    ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      lines[i].render(ctx, i > 0);
      lines[i].staticOffset = null;
    }

    //set fillStyle and strokeStyle colors
    const isShapeHovering = shape.isHoveringOnlyShape();
    let shapeColorSet;

    function renderColorSetTemplate(shapeColorSet, isShapeHovering) {
      if (isShapeHovering) {// && workspace.getHoverShape() === shape ) {
        ctx.strokeStyle = shapeColorSet.primary_border;
        ctx.fillStyle = shapeColorSet.primary_hover;
      } else {
        ctx.strokeStyle = shapeColorSet.primary_border;
        ctx.fillStyle = shapeColorSet.primary;
      }
    }

    function renderFilledPrimaryTemplate(isShapeHovering) {
      if (isShapeHovering) {// && workspace.getHoverShape() === shape ) {
        ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;
        ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].active_transparent;
      } else {
        ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
        ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_transparent;
      }
    }

    function renderFilledActiveTemplate(isShapeHovering) {
      if (isShapeHovering) {// && workspace.getHoverShape() === shape ) {
        ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active_hover;
        ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_transparent;
      } else {
        ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
        ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].active_transparent;
      }
    }

    function renderDisabledTemplate(isShapeHovering) {
      if (isShapeHovering) {
        ctx.strokeStyle = COLOR.gray4_transparent;
        ctx.fillStyle = COLOR.lightgray4_transparent;
      } else {
        ctx.strokeStyle = COLOR.gray4_transparent;
        ctx.fillStyle = COLOR.lightgray4_transparent;
      }
    }

    switch (fillTemplate) {
      case RENDER_TEMPLATES.accordingToFeature:
        shapeColorSet = shape.getColorSet();
        if (shapeColorSet) {
          renderColorSetTemplate(shapeColorSet, isShapeHovering);
        } else {
          renderFilledPrimaryTemplate(isShapeHovering);
        }
        break;
      case RENDER_TEMPLATES.disabled:
        renderDisabledTemplate(isShapeHovering);
        break;
      case RENDER_TEMPLATES.filledPrimary:
        renderFilledPrimaryTemplate(isShapeHovering);
        break;
      case RENDER_TEMPLATES.filledActive:
        renderFilledActiveTemplate(isShapeHovering);
        break;
    }

    //set hover style colors
    if (isShapeHovering) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton === SIDEBAR_BUTTONS_MENU.delete
        && !isShowSlabTool
      ) {
        ctx.fillStyle = Colors.red
      }
    }

    //set lineWidth
    switch (strokeTemplate) {
      case RENDER_TEMPLATES.linesOnly:
        ctx.lineWidth = 0;
        ctx.closePath();
        break;
      case RENDER_TEMPLATES.default:
      default:
        ctx.fill();
        ctx.lineWidth = 2; // Math.ceil(scale);
        ctx.closePath();
        ctx.stroke();
        break;
    }
  }

  static getBoundingBoxFromShape = (shape) => {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    const lines = shape.getLines();
    for (let line of lines) {
      const renderTo = line.calculateRenderPosition(line.to);
      const renderFrom = line.calculateRenderPosition(line.from);

      minX = Math.min(minX, renderFrom.x, renderTo.x);
      minY = Math.min(minY, renderFrom.y, renderTo.y);
      maxX = Math.max(maxX, renderFrom.x, renderTo.x);
      maxY = Math.max(maxY, renderFrom.y, renderTo.y);
    }

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  };

  /**
   * Function for drawing a rectangle with angled stripes and transparency.
   *
   * @param ctx
   * @param {Number} x - x-coordinate of the top-left corner of the rectangle
   * @param {Number} y - y-coordinate of the top-left corner of the rectangle
   * @param {Number} width - width of the rectangle
   * @param {Number} height - height of the rectangle
   * @param {Number} lineWidth - width of the stripe
   * @param {Number} angle - angle of the stripes in degrees
   * @param {String} color1 - first color (background with transparency)
   * @param {String} color2 - second color (stripe color with transparency)
   */
  static drawStripedRectangle = (
    ctx,
    x,
    y,
    width,
    height,
    lineWidth = 3 * 3.5,
    angle = 3 * 1000,
    color1 = "rgba(255, 255, 255, 0.5)", // Semi-transparent background
    color2 = "rgba(230, 228, 230, 0.5)" // Semi-transparent stripes
  ) => {
    const lineGap = 6 * 3.5;

    ctx.save();

    // Define clipping area (visible rectangle)
    ctx.beginPath();
    ctx.rect(x, y, width, height);
    ctx.fillStyle = color1;
    ctx.fill();
    ctx.clip();

    // Draw diagonal lines across the entire canvas
    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = color2;

    // The pattern should cover the entire canvas
    for (let i = -ctx.canvas.width * 2; i < ctx.canvas.width; i += lineGap) {
      ctx.moveTo(i, -ctx.canvas.height);
      ctx.lineTo(i + lineGap + angle, ctx.canvas.height * 2);
    }

    ctx.stroke();
    ctx.restore();
  };

  /**
   *
   * @param ctx
   * @param {Number} x - координата x верхнего левого угла прямоугольника
   * @param {Number} y - координата y верхнего левого угла прямоугольника
   * @param {Number} width - ширина прямоугольника
   * @param {Number} height - высота прямоугольника
   */
  static fillStripedRectangle = (ctx, x, y, width, height) => {
    let gradient = ctx.createLinearGradient(x, y, width, height);
    gradient.addColorStop(0.25, '#868d91');
    gradient.addColorStop(0.25, '#7b8185');
    gradient.addColorStop(0.5, '#7b8185');
    gradient.addColorStop(0.5, '#868d91');
    gradient.addColorStop(0.75, '#868d91');
    gradient.addColorStop(0.75, '#7b8185');
    gradient.addColorStop(1, '#7b8185');

    // Заливка шейпа градиентом
    ctx.fillStyle = gradient;
    ctx.fill();
  }

  static drawDiagonalStripesV2 = (ctx, shape, lineWidth = 2, rotationAngle = -Math.PI / 4) => {
    const bbox = RenderParts.getBoundingBoxFromShape(shape);
    void rotationAngle;
    void lineWidth;

    ctx.save();
    let lines = shape.getLines();

    //draw border
    ctx.beginPath();
    ctx.rect(bbox.x, bbox.y, bbox.width, bbox.height);
    ctx.lineWidth = 2;
    ctx.stroke();

    for (let i = 0; i < lines.length; i++) {
      //lines[i].render(ctx, i > 0);
    }
    const pointPos = lines[1].calculateRenderPosition(lines[1].to);

    RenderParts.fillStripedRectangle(ctx, bbox.x, bbox.y, pointPos.x, pointPos.y);
    ctx.closePath();

    ctx.restore();
  };

  static drawDiagonalStripes = (ctx, shape, lineWidth = 2, rotationAngle = -Math.PI / 4) => {
    const bbox = RenderParts.getBoundingBoxFromShape(shape);
    // const lightGray = '#80848a';
    // const darkGray = '#787c82';
    const lightGray = '#5a5c61';
    const darkGray = '#54575b';
    void rotationAngle;

    // ctx.save();
    // let lines = shape.getLines();
    // // ctx.beginPath();
    // // ctx.rect(bbox.x, bbox.y, bbox.width, bbox.height);
    // ctx.beginPath();
    // for (let i = 0; i < lines.length; i++) {
    //   lines[i].render(ctx, i > 0);
    // }
    // ctx.closePath();
    // ctx.clip();
    //
    // ctx.lineWidth = 2;
    // ctx.stroke();
    //
    // for (let i = 0; i < lines.length; i++) {
    //   lines[i].render(ctx, i > 0);
    // }
    // ctx.closePath();
    // ctx.clip();

    const scale = config.scale;
    const scaledLineWidth = lineWidth * scale;

    RenderParts.drawStripedRectangle(
      ctx,
      bbox.x,
      bbox.y,
      bbox.width,
      bbox.height,
      scaledLineWidth,
      3 * 1000,
      lightGray,
      darkGray
    );

    ctx.restore();
  };


  static drawBorders = (ctx,
                        staticOffset,
                        lines = [],
                        shouldRenderOnlyHovered = true,
                        style = {
                          lineWidth: 3,
                          strokeStyle: COLOR_THEMES[sqftConfig.activeTheme].primary_hover,
                          shadowBlur: 4,
                          extendHoveredLine: 0
                        },

  ) => {

    for (let i = 0; i < lines.length; i++) {
      if (shouldRenderOnlyHovered && lines[i].getState().isHovering || !shouldRenderOnlyHovered) {
        ctx.save();
        ctx.beginPath();
        lines[i].staticOffset = staticOffset;
        ctx.lineWidth = style.lineWidth;
        ctx.shadowColor  = ctx.strokeStyle = style.strokeStyle;
        ctx.shadowBlur = style.shadowBlur;

        let pointTo = {...lines[i].to};
        let pointFrom = {...lines[i].from};
        if (style.extendHoveredLine > 0) {
          pointFrom = {pos: getPointOnTheLine(lines[i].from, lines[i].to, 5)};
          pointTo = {pos: getPointOnTheLine(lines[i].to, lines[i].from, 5)};
        }
        const renderTo = lines[i].calculateRenderPosition(pointTo);
        const renderFrom = lines[i].calculateRenderPosition(pointFrom);

        ctx.moveTo(renderTo.x, renderTo.y);
        ctx.lineTo(renderFrom.x, renderFrom.y);
        lines[i].staticOffset = null;

        ctx.stroke();
        ctx.closePath();
        ctx.restore();
      }
    }
  }

  static drawSpacerBorders = (ctx, staticOffset, shape) => {
    let lines = shape.getLines();
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_transparent8;
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      if (i === 0) {
        const renderFrom = lines[i].calculateRenderPosition(lines[i].from);
        ctx.moveTo(renderFrom.x, renderFrom.y);
      }
      const renderTo = lines[i].calculateRenderPosition(lines[i].to);
      ctx.lineTo(renderTo.x, renderTo.y);

      lines[i].staticOffset = null;
    }

    //set hover style colors
    if (shape.isHovering()) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton === SIDEBAR_BUTTONS_MENU.delete) {
        ctx.fillStyle = Colors.red
      }
    }

    ctx.closePath();
    ctx.stroke();
    ctx.fill();
    ctx.restore();
  }

  static drawShapeCrownMoldings = (ctx, staticOffset, shape) => {
    let lines = shape.getLines();
    //ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      if (lines[i].getState().attachedItems.isWithCrownMolding) {
        const crownMoldingPoints = getLineCrownMoldingPoints(lines[i]);
        ctx.save();
        if (lines[i].isHovering()) {
          const reduxState = store.getState();
          const activeButton = reduxState.sqftMenuState.activeButton;
          if (activeButton === SIDEBAR_BUTTONS_MENU.delete) {
            ctx.strokeStyle = Colors.red
          }
        }
        RenderCabinets.renderCrownMolding(ctx, crownMoldingPoints);
        ctx.restore();
      }
      lines[i].staticOffset = null;
    }
  }

  static drawShapeEndCap = (ctx, staticOffset, shape) => {
    let lines = shape.getLines();
    //ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      const lineState = lines[i].getState();
      if (lineState.attachedItems && lineState.attachedItems.isWithEndCap) {
        ctx.save();
        if (lines[i].isHovering()) {
          const reduxState = store.getState();
          const activeButton = reduxState.sqftMenuState.activeButton;
          if (activeButton === SIDEBAR_BUTTONS_MENU.delete) {
            ctx.strokeStyle = Colors.red
          }
        }
        RenderCabinets.renderEndCap(ctx, lines[i]);
        ctx.restore();
      }
      lines[i].staticOffset = null;
    }
  }

  static drawFrontLines = (ctx, shape, lines, shouldDrawArrowDirection) => {
    if (!Array.isArray(lines)) {
      return;
    }

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (!line?.from || !line?.to) {
        continue;
      }

      const midPoint = getMidPoint(line.from, line.to);
      const renderPosition = getPointField(midPoint.x, midPoint.y, shape);
      const shapeCenter = shape.getCenter();
      const shapeCenterPosition = getPointField(shapeCenter.x, shapeCenter.y, shape);
      const lineFromPosition = line.from.getPointField();
      const lineToPosition = line.to.getPointField();

      if (shouldDrawArrowDirection) {
        RenderFigures.renderArrowInCircle(
          ctx,
          renderPosition,
          lineFromPosition,
          lineToPosition,
          shapeCenterPosition
        );
      }
    }
  };


  static drawHandles = (ctx, shape, lines) => {
    for (let i = 0; i < lines.length; i++) {
      const midPoint = getMidPoint(lines[i].from, lines[i].to);
      const renderPosition = getPointField(midPoint.x, midPoint.y, shape);
      RenderFigures.renderHandle(ctx, renderPosition);
    }
  }

  static renderDevMode = (ctx, shape) => {
    // render __intersectionPoints
    const intersectionPoints = shape.shapeAbsolute.getIntersectionPoints()
    if (intersectionPoints) {
      for (let i in intersectionPoints) {
        intersectionPoints[i].forEach(intPoint => {
          ctx.beginPath();
          ctx.arc(intPoint.x, intPoint.y, 20, 0, 2 * Math.PI);
          ctx.stroke();
          ctx.closePath();
        })
      }
    }
    // render slabPos
    ctx.beginPath();
    let pf = getPointField(shape.slabPos.x, shape.slabPos.y);
    ctx.arc(pf.x, pf.y, 10, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.closePath();

    // render absolutePos
    const absolutePos = shape.shapeAbsolute.getAbsolutePosition();
    if (absolutePos) {
      ctx.beginPath();
      ctx.strokeStyle = '#a02f2f';
      pf = getPointField(absolutePos.x, absolutePos.y)
      ctx.arc(pf.x, pf.y, 5, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();
    }
  }
}
